<template>
    <div class="certiadd-wrapper">
        <div class="title-box ds-flex">
          <h1 class="tab-title">기술 / 특허 추가</h1>
        </div>
        <div class="contents-box">
            <div class="gray-box ds-flex start-between">
                <div class="left">
                    <div class="data-box short">
                        <h3 class="item-title">분류</h3>
                        <div class="input-box select" :style="comboBox.style">
                            <div 
                                v-for="(option, i) in comboBox.option" 
                                :key="option" 
                                class="option ds-flex center-between" 
                                @click="setComBox(option);"
                            >
                                {{ option }}
                                <svg id="arrow" v-if="i===0" width="15" height="9" viewBox="0 0 15 9" fill="none" xmlns="http://www.w3.org/2000/svg">
                                    <path d="M15.0006 1.8577C15.0006 2.06371 14.927 2.26972 14.7432 2.44139L8.34616 8.72466C8.34616 8.72466 7.94175 8.99933 7.6844 8.99933C7.42704 8.99933 7.20646 8.89633 7.02263 8.75899L0.257927 2.47573C-0.072955 2.13238 -0.072955 1.58303 0.257927 1.23968C0.58881 0.89633 1.21381 0.930665 1.58146 1.23968L7.6844 6.90491L13.4197 1.27401C13.7873 0.930665 14.3388 0.930665 14.7065 1.27401C14.8903 1.44569 15.0006 1.68603 15.0006 1.89204V1.8577Z" :fill=comboBox.fill />
                                </svg>
                            </div>
                        </div>
                    </div>
                    <div class="data-box short">
                        <h3 class="item-title">제목</h3>
                        <input 
                            type="text" 
                            v-model="certiData.title" 
                            class="input-box input"
                            :class="{'filled' : certiData.title!==''}" 
                            placeholder="제목을 입력해주세요."
                            @input="checkInput()"
                        >
                    </div>
                    <div class="data-box short">
                        <h3 class="item-title">내용</h3>
                        <input 
                            type="text"
                            v-model="certiData.contents" 
                            class="input-box input" 
                            :class="{'filled' : certiData.contents!==''}" 
                            placeholder="내용을 입력해주세요."
                            @input="checkInput()"
                        >
                    </div>
                    <div class="data-box long">
                        <div class="file-box ds-flex center-between">
                            <h3 class="item-title">파일 첨부</h3>
                            <input
                                type="file"
                                ref="upload"
                                @change="setFileList(); checkInput();"
                                style="display: none;"
                                accept="image/*"
                            />
                            <div class="ds-flex">
                                <div class="btn blue" @click="$refs.upload.click()">파일 추가</div>
                                <div class="btn gray delete" @click="emptyFile(); checkInput();">파일 삭제</div>
                            </div>
                        </div>
                        <input 
                            type="text" 
                            v-model="certiData.originName" 
                            class="input-box input file" 
                            :class="{'filled' : certiData.originName!==''}" 
                            placeholder="첨부된 파일이 없습니다." 
                            @click="$refs.upload.click()"
                            readonly
                        >
                    </div>
                    <div class="data-box short">
                        <h3 class="item-title">작성자</h3>
                        <input type="text" v-model="certiData.writer" class="input-box text" readonly>
                    </div>
                </div>
                <div class="right">
                    <div class="data-box">
                        <h3 class="item-title preview">이미지 미리보기</h3>
                        <div class="preview-box">
                            <div v-if="file.src === ''" class="noimage-box">
                                <img src="@/assets/admin/img_icon.png">
                                <p class="noimage-text">No image</p>
                            </div>
                            <img v-else :src="file.src">
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div class="bottom-box ds-flex center-center">
          <div class="btn-box ds-flex">
            <div class="btn gray" :class="{'active' : certiData.isFilled}" @click="saveList()">{{ msg }}</div>
            <div class="btn blue" @click="movePage('Certificate')">취소</div>
          </div>
        </div>

        <div v-if="showPopup" class="popup-wrapper">
        <!-- <div class="popup-wrapper"> -->
            <div class="popup-box ds-flex center-center">
                <img src="@/assets/login/check_icon.png">
                <div class="popup-text-box ds-flex center-center">
                    <h3 class="ds-flex center-center">기술 / 특허 추가 완료</h3>
                    <p class=" ds-flex center-center">작성하신 내용으로 업로드가 완료되었습니다.</p>
                </div>
                <div class="blue-btn" @click="showPopup=false; movePage('Certificate')">확인</div>
            </div>
        </div>
    </div>
</template>

<script>
import axios from "axios"
import {API} from "../../api.js";

export default {
  name: 'CertificateAdd',
  components: {
  },
  data: () => ({
    user: {},
    upload: {
        server: '',
        dir: 'upload',
        menu: 'certificate',
    },
    showPopup: false,
    file: { // 업로드된 파일
        data: '', // 파일 정보
        src: '', // 이미지 미리보기용 임시 경로
    },
    certiData:{
        idx: '',
        category: '',
        title: '',
        contents: '',
        originName: '', // 원본 파일 이름
        uploadName: '', // 업로드된 파일 이름
        writer: 'admin',
        isFilled: false,
        order: ''
    },
    comboBox:{ 
        isopen: false,
        style: {},
        origin: ['인증서', '특허증 및 저작권 등록증', 'PCT 국제출원'], // 기존 순서
        option: [], // 사용자가 선택한 옵션에 따라 순서가 바뀜
        selected: '', // 사용자가 선택한 옵션
        fill: '#14141C', // 화살표 색상
    },
    msg: '추가'
  }),
  methods: {
    // idx가 존재하면 해당되는 리스트를 가져온다.
    getCertiList() {
        let singleton = this;
        let param = {
            table: this.upload.menu,
            idx: this.certiData.idx,
            option: ''
        }
        API.getList(param, function(status, res){
            let data = singleton.certiData;
            let upload = singleton.upload;
            let file = singleton.file;

            for(let key in data){
                if(key === 'originName') {
                    data[key] = res.data[0]['origin_name'];
                } else if(key === 'uploadName') {
                    data[key] = res.data[0]['upload_name'];
                    file.src = upload.server+'/'+upload.dir+'/'+upload.menu+'/'+res.data[0]['upload_name'];
                } else {
                    data[key] = res.data[0][key];
                }

                if(key === 'category'){
                    singleton.comboBox.selected = res.data[0][key];
                }
            }

            
            data.isFilled = true;
            singleton.setOption();
        })
    },
    /* 선택한 파일을 저장하고, 미리보기 경로를 받아온다. */
    async setFileList() {
        let file = this.$refs.upload.files[0];
        this.file.data = file;
        this.file.src = URL.createObjectURL(file); // 미리보기 경로 생성
        this.certiData.originName = file.name;
    },
    // 파일을 업로드한다.
    async uploadFile(blob) {
        const formData = new FormData();
        formData.append('image', blob);

        return axios(this.upload.server + '/upload/file', {
            method: 'POST',
            data: formData,
            headers : {'Content-type' : 'multipart/form-data'},
            params: {'menu': this.upload.menu}
        }).then(response => {
            if (response.data) {
                return response.data.uploadName;
            }
            throw new Error('Server or network error');
        }).catch( () => {
            console.log('error..');
            return false;
        });
    },
    // 업로드된 파일을 삭제한다.
    async removeFile(fileName) {
        return axios(this.upload.server + '/delete/file', {
            method: 'POST',
            data: '',
            headers : {},
            params: {'menu': this.upload.menu, 'fileName': fileName}
        }).then(response => {
            if (response.data) {
                console.log('success .. >> ', response.data);
            }
            // throw new Error('Server or network error');
        }).catch( () => {
            console.log('error..');1
            return false;
        });
    },
    emptyFile() {
        this.file.src = '';
        this.certiData.originName = '';
    },
    async getSeq() { // 정렬 순서를 얻어온다.
      return axios(this.upload.server + '/get/seq', {
            method: 'GET',
            data: '',
            headers : {},
            params: {'table': this.upload.menu, 'option': this.certiData.category}
        }).then(response => {
            if (response.data) {
                return response.data[0].seq;
            }
            // throw new Error('Server or network error');
        }).catch( () => {
            console.log('error..');
            return false;
        });
    },
    async saveList() {
        let data = this.certiData;
        if(data.isFilled) {
            this.showPopup = true;

            if(this.file.data !== '') {
                if(data.uploadName !== '') { // 기존 리스트를 수정하는 경우
                    await this.removeFile(data.uploadName);
                }
                data.uploadName = await this.uploadFile(this.file.data);
            }

            if(data.idx !== undefined) { // UPDATE
                API.updateCertiList(data, function(status, res){
                    if(status==='error'){
                        console.log('error', res);
                    }
                })
            } else { // INSERT
                data.order = await this.getSeq();
                API.insertCertiList(data, function(status, res){
                    if(status==='error'){
                        console.log('error', res);
                    }
                })
            }
            
        }
    },
    setCurrTab(tab) {
      this.$router.push({name: tab.name});
      this.currTab = tab;
    },
    setOption() {
        let comb = this.comboBox;
        comb.option = [];
        
        if(comb.selected === '') {
            for(let i=0; i<comb.origin.length; i++) {
                comb.option.push(comb.origin[i]);
            }
        } else {
            comb.option.push(comb.selected);
            for(let i=0; i<comb.origin.length; i++) {
                if(comb.origin[i] !== comb.selected) {
                    comb.option.push(comb.origin[i]);
                }
            }
        }
    },
    setComBox(selected) {
        let comb = this.comboBox;
        let select = document.getElementsByClassName('select')[0];
        let option = document.getElementsByClassName('option');
        let arrow = document.getElementById('arrow');
        
        if(comb.isopen) {
            for(let i=0; i<option.length; i++) {
                option[i].classList.remove('hover', 'active');
            }
            select.classList.remove('active');
            comb.style = {};
            comb.fill = '#14141C';
            comb.selected = selected;
            this.certiData.category = selected;
            arrow.style.transform = `rotate(360deg)`
            this.setOption();
        } else {
            select.classList.add('active');
            for(let i=0; i<option.length; i++) {
                if(i===0) { option[i].classList.add('hover', 'active'); } // comboBox가 열려있을 경우에만 hover css 동작하도록
                else { option[i].classList.add('hover'); }
            }
            comb.style = {'border-color': '#00ACEB'};
            comb.fill = '#00ACEB';
            arrow.style.transform = `rotate(180deg)`
        }
        
        comb.isopen = !comb.isopen;
    },
    // 모든 값이 입력되었는지 확인한다.
    checkInput() {
        for(let key in this.certiData){
            if(key !== 'uploadName' && key !== 'contents' && key !== 'order' && this.certiData[key] === '') {
                this.certiData.isFilled = false;
                break;
            } else {
                this.certiData.isFilled = true;
            }
        }
    },
    movePage(name) {
      this.$router.push({name: name});
    },
  },
  mounted() {
    window.scrollTo(0,0);
    let data = this.certiData;
    // this.user = JSON.parse(sessionStorage.getItem('user_info'));
    // data.writer = this.user.id;
    data.idx = this.$route.query.idx;
    if(data.idx) {
        this.getCertiList();
        this.msg = '수정';
    } else {
        data.category = this.comboBox.origin[0];
        this.setOption();
    }
  },
  created() {
  }
}
</script>

<style scoped>
.certiadd-wrapper {
    /* min-height: 1080px; */
    overflow: auto;
}

.title-box {
  width: 100%;
  height: 70px;
  padding: 15px 30px;
  box-sizing: border-box;
  align-items: center;
}

.tab-title {
  color: #14141C;
  font-weight: 700;
  font-size: 20px;
  line-height: 24px;
}

.count-box {
  color: #B3B6C0;
  font-size: 15px;
  line-height: 18px;
  margin-left: 15px;
}

.blue-highlight {
  color: #00ACEB;
  font-weight: 600;
  margin-left: 3px;
}

.contents-box {
  padding: 0 20px;
}

.table-header {
  width: 100%;
  height: 40px;
  background-color: #555861;
}

.table-th {
  display: flex;
  align-items: center;
  justify-content: center;
  height: 40px;
  border-right: 1px solid #fff;
  box-sizing: border-box;
  color: #fff;
  font-size: 15px;
  font-weight: 600;
  line-height: 18px;
}

.table-th:last-child {
  border-right: none;
}

.table-th.title {
  width: calc(100% - 400px);
}

.check-box {
  width: 40px;
}

.check-box img {
  cursor: pointer;
}

.table-body {
  padding-top: 6px;
}

.table-td {
  display: flex;
  align-items: center;
  justify-content: center;
  height: 40px;
  background-color: #fff;
  border: 1px solid #DCDEE2;
  box-sizing: border-box;
}

.table-td.title {
  width: calc(100% - 400px);
  justify-content: flex-start;
  padding-left: 13px;
}

.no-data-box {
  width: 100%;
  height: 880px;
  background-color: #F2F2F5;
  border: 1px solid #B3B6C0;
  color: #707070;
  font-size: 15px;
  box-sizing: border-box;
}

.btn-box {
  position: absolute;
  right: 20px;
}

.btn {
  width: 110px;
  height: 40px;
  border-radius: 5px;
  background-color: #F2F2F5;
  border: 1px solid;
  font-size: 15px;
  display: flex;
  align-items: center;
  justify-content: center;
  transition: .3s;
  margin-right: 10px;
  font-weight: 600;
  box-sizing: border-box;
}

.btn:last-child {
  margin-right: 0;
}

.btn.blue {
  cursor: pointer;
  border-color: #00ACEB;
  color: #00ACEB;
}

.btn.blue:hover {
  color: #fff;
  background-color: #00ACEB;
}

.btn.gray {
  border-color: #B3B6C0;
  color: #B3B6C0;
}

.btn.delete:hover {
    cursor: pointer;
    border-color: #FF3E3E;
    color: #FF3E3E;
}
.btn.active {
    border-color: #00ACEB;
    color: #00ACEB;
    cursor: pointer;
}

.btn.active:hover {
    background-color: #00ACEB;
    color: #fff;
}

.bottom-box {
  position: relative;
  height: 80px;
  padding: 20px;
  box-sizing: border-box;
}

.gray-box {
    width: 100%;
    background-color: #E3E4EA;
    border: 1px solid #B3B6C0;
    padding: 50px;
    box-sizing: border-box;
}

.item-title {
    color: #14141C;
    font-weight: 500;
    font-size: 17px;
    line-height: 20px;
    text-align: left;
}

.item-title.preview {
    margin-bottom: 15px;
}

.data-box {
    position: relative;
    /* max-width: 710px; */
    display: flex;
    flex-wrap: wrap;
    align-content: space-between;
    margin-top: 40px;
}

.data-box:first-child {
    margin-top: 0;
}

.short {
    height: 75px;
}

.long {
    height: 80px;
}

.input-box {
    width: 100%;
    height: 40px;
    border: 1.5px solid #B3B6C0;
    border-radius: 5px;
    background-color: #F2F2F5;
    box-sizing: border-box;
    transition: .3s;
    color: #14141c;
    font-weight: 400;
    font-size: 15px;
    line-height: 18px;
}

.input-box:hover {
    border-color: #00ACEB;
}

.input-box:focus {
    border-color: #00ACEB !important;
}

.input-box.input {
    padding: 11px 15px;
}

.input-box.text {
    border: none;
    border-bottom: 1px solid #14141C;
    border-radius: 0px;
    background-color: transparent;
    padding: 11px 15px;
}

.input-box.select {
    position: absolute;
    top: 35px;
    transition: .3s;
    overflow: hidden;
    border-color: #14141C;
    cursor: pointer;
    z-index: 10;
}

.input-box.select.active {
    height: 120px;
}

.input-box.select:hover {
    border-color: #00ACEB;
}

.input-box.select:hover path {
    fill: #00ACEB;
    transition: .3s;
}

.input-box.select .option {
    height: 40px;
    padding: 0 15px;
    transition: .3s;
}

.input-box.select .option:hover {
    color: #00ACEB;
    background-color: #E0E9F5;
}

.input-box.filled {
    border-color: #14141C;
}

.file-box {
    width: 100%;
}

.file-box  .btn {
    width: 80px;
    height: 30px;
    font-size: 12px;
    line-height: 14px;
}

.left {
    width: calc(100% - 600px);
    min-width: 560px;
}

.right {
    width: 560px;
}

.preview-box {
    width: 560px;
    height: 792px;
    border: 1px solid #B3B6C0;
    background-color: #F2F2F5;
    transition: .3s;
    box-sizing: border-box;
}

.preview-box > img {
    width: 100%;
    height: 100%;
}

.noimage-box {
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
}

.noimage-text {
    color: #B3B6C0;
    font-weight: 600;
    font-size: 15px;
    line-height: 18px;
    margin-top: 5px;
}

.popup-wrapper {
    width: 100%;
    height: 100vh;
    background-color: rgba(14, 14, 19, 0.7);
    position: absolute;
    top: 0;
    left: 0;
    z-index: 30;
}

.popup-box {
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    width: 380px;
    height: 200px;
    background-color: #fff;
    box-sizing: border-box;
    padding: 29px 0;
}

.popup-box h3 {
    width: 100%;
    color: #000000;
    font-size: 15px;
    font-weight: bold;
    height: 18px;
    align-content: center;
    margin-bottom: 10px;
}

.popup-box p {
    font-size: 12px;
    color: #000000;
    height: 14px;
    width: 100%;
    align-content: center;
}
 
.popup-box .blue-btn {
    width: 80px;
    height: 30px;
    font-size: 12px;
    margin: 0 5px;
    background-color: #00ACEB;
    align-content: center;
    cursor: pointer;
    transition: .3s;
    color: #fff;
    border-radius: 5px;
}

.popup-box .blue-btn:hover {
    background-color: #0088BB;
}

.popup-text-box {
    width: 100%;
    height: 82px;
    align-content: center;
}

.input-box.file {
    cursor: pointer;
}

@media screen and (max-width: 1439px) {
    .contents-wrapper {
        width: calc(100% - 270px);
    }

    .contents-box {
      padding: 0 15px;
    }

    .left {
        width: calc(100% - 400px);
        min-width: 415px;
    }

    .right {
        width: 360px;
    }

    .title-box {
      padding: 12px 20px;
      height: 40px;
      align-content: center;
    }

    .tab-title {
      font-size: 14px;
      line-height: 17px;
    }

    .item-title {
        font-size: 11px;
        line-height: 13px;
        padding-left: 5px;
    }

    .item-title.preview {
        margin-bottom: 5px;
    }

    .short {
        height: 48px;
    }

    .long {
        height: 55px;
    }

    .input-box {
        height: 30px;
        font-size: 11px;
        border-radius: 3px;
    }

    .input-box.input {
        padding: 5px 10px;
    }

    .input-box.text {
        padding: 5px 10px;
    }

    .input-box.select {
        top: 18px;
        z-index: 5;
    }

    .input-box.select.active {
        height: 120px;
    }

    .input-box.select .option {
        height: 30px;
        padding: 0 10px;
    }

    .input-box.number {
        width: 165px;
    }

    .posit {
        margin-right: 10px;
    }

    #arrow {
        width: 12px;
    }

    .data-box {
        margin-top: 20px;
    }

    .data-box p {
        font-size: 11px;
    }

    .file-box .btn {
        width: 55px;
        height: 20px;
        border-radius: 3px;
        font-size: 9px;
        margin-right: 5px;
    }

    .file-box .btn:last-child {
        margin-right: 0;
    }

    .btn {
        width: 80px;
        height: 25px;
        border-radius: 3px;
        font-size: 11px;
    }

    .gray-box {
        padding: 25px 30px;
    }

    .bottom-box {
        padding: 13px 0;
        height: 50px;
    }

    .preview-box {
        width: 360px;
        height: 510px
    }
}
</style>
